module.exports = __webpack_public_path__ + "img/ico-tobahotelinternational.5981e8ac.png";